import React from 'react';
import { useNavigate } from 'react-router-dom';
import HrnbContainer from '../components/controls/HrnbContainer';
import HrnbButton from '../components/controls/HrnbButton';
import { ClearIcon } from '../icons';
import CreateBattleForm from '../components/battles/CreateBattleForm';
import '../css/pages/CreateBattlePage.css';

/**
 * Страница создания нового баттла
 */
function CreateBattlePage() {
    const navigate = useNavigate();

    const handleSuccess = (newBattle) => {
        // Перенаправляем на страницу созданного баттла
        navigate(`/battles/${newBattle.id}`);
    };

    const handleClose = () => {
        // Возвращаемся на страницу списка баттлов
        navigate('/battles');
    };

    return (
        <HrnbContainer className="create-battle-page">
            <div className="create-battle-page__header">
                <h2 className="create-battle-page__title">Создание баттла</h2>
                <HrnbButton
                    variant="outline"
                    onClick={handleClose}
                    icon={<ClearIcon />}
                >
                    Отмена
                </HrnbButton>
            </div>
            
            <CreateBattleForm
                isOpen={true}
                onClose={handleClose}
                onSuccess={handleSuccess}
                useModal={false}
            />
        </HrnbContainer>
    );
}

export default CreateBattlePage;
